import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import { createProfile } from "../../../domain/profile/profileActions";
import ProfileCreateForm from "../../forms/secure/profile/ProfileCreateForm/ProfileCreateForm";
import StatusMessage from "../../presentational/StatusMessage";
import * as StatusMessages from "../../../constants/StatusMessages";
import { FormattedMessage } from "react-intl";
import track from "react-tracking";
class ProfileCreate extends Component {
    /* --- React Lifecycle Methods --- */
    /**
     * React lifecycle method
     *
     * @method render
     * @private
     * @returns {HTMLElement} Component element
     */
    render() {
        const { props } = this;
        const { profile } = props;
        return (<div className="wrapper wrapper_narrow">
				<div className="vr vr_x4">
					<h2 className="hdg js-pageHeader">
						<FormattedMessage id="profileCreate.header" defaultMessage="My Personal Information"/>
					</h2>
				</div>
				<StatusMessage isError isActive={this.props.profileError ? true : false} error={this.props.profileError ? this.props.profileError : null} customMessage={StatusMessages.PROFILE.CREATE_ERROR_INTRO} domain="profile"/>
				<StatusMessage isError={!this.props.profileIsSuccess} isSuccess={this.props.profileIsSuccess} isActive={this.props.profileIsSuccess !== null ? true : false} customMessage={this.props.profileIsSuccess ?
            StatusMessages.PROFILE.SUCCESS_MESSAGE_PROFILE :
            ""} domain="profile"/>
				{profile != null && (<div>
						<div className="vr vr_x5">
							<div className="text">
								<FormattedMessage id="profileCreate.email" defaultMessage="Your email address: {email}" values={{
            email: (this.props.profile || {}).email
        }}/>
							</div>
						</div>
						<div className="vr vr_x4">
							<ProfileCreateForm createProfile={this.props.createProfile} profile={this.props.profile} fieldErrors={this.props.profileFieldErrors} isLoading={this.props.profileIsLoading}/>
						</div>
					</div>)}
				<StatusMessage isLoad isActive={this.props.profileIsLoading ? true : false}/>
				<div className="vr vr_x5">
					<div className="text">
						<FormattedMessage tagName="p" id="profileCreate.contact" defaultMessage="Need help? {link}" values={{
            link: (<Link className="link" to="/secured/contact">
										<FormattedMessage id="profileCreate.contact.link" defaultMessage="Contact Us."/>
									</Link>)
        }}/>
					</div>
				</div>
			</div>);
    }
}
/* --- React Redux bootstrapping --- */
const mapStateToProps = (state) => ({
    profile: state.profile.profile,
    profileError: state.profile.error,
    profileFieldErrors: state.profile.fieldErrors,
    profileIsLoading: state.profile.isLoading,
    profileIsSuccess: state.profile.isSuccess
});
const bindActionsToProps = {
    createProfile
};
/* Create and export container component that wraps ProfileCreate for property binding */
export default track({ page: "ProfileCreate" }, { dispatchOnMount: true })(connect(mapStateToProps, bindActionsToProps)(ProfileCreate));



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/ProfileCreate.tsx